import React from 'react';
import { Check } from 'lucide-react';
interface WizardProgressProps {
  currentStep: number;
  steps: string[];
}
export function WizardProgress({
  currentStep,
  steps
}: WizardProgressProps) {
  return <nav aria-label="Progress" data-id="element-431">
      <ol role="list" className="flex items-center" data-id="element-432">
        {steps.map((step, index) => {
        const stepIdx = index + 1;
        return <li key={step} className={`${index !== steps.length - 1 ? 'pr-8 sm:pr-20' : ''} relative`} data-id="element-433">
              {stepIdx < currentStep ? <>
                  <div className="absolute inset-0 flex items-center" aria-hidden="true" data-id="element-434">
                    <div className="h-0.5 w-full bg-red-600" data-id="element-435" />
                  </div>
                  <a href="#" className="relative flex h-8 w-8 items-center justify-center rounded-full bg-red-600 hover:bg-red-900" data-id="element-436">
                    <Check className="h-5 w-5 text-white" aria-hidden="true" data-id="element-437" />
                    <span className="sr-only" data-id="element-438">{step}</span>
                  </a>
                </> : stepIdx === currentStep ? <>
                  <div className="absolute inset-0 flex items-center" aria-hidden="true" data-id="element-439">
                    <div className="h-0.5 w-full bg-gray-200" data-id="element-440" />
                  </div>
                  <a href="#" className="relative flex h-8 w-8 items-center justify-center rounded-full border-2 border-red-600 bg-white" aria-current="step" data-id="element-441">
                    <span className="h-2.5 w-2.5 rounded-full bg-red-600" aria-hidden="true" data-id="element-442" />
                    <span className="sr-only" data-id="element-443">{step}</span>
                  </a>
                </> : <>
                  <div className="absolute inset-0 flex items-center" aria-hidden="true" data-id="element-444">
                    <div className="h-0.5 w-full bg-gray-200" data-id="element-445" />
                  </div>
                  <a href="#" className="relative flex h-8 w-8 items-center justify-center rounded-full border-2 border-gray-300 bg-white hover:border-gray-400" data-id="element-446">
                    <span className="h-2.5 w-2.5 rounded-full bg-transparent group-hover:bg-gray-300" aria-hidden="true" data-id="element-447" />
                    <span className="sr-only" data-id="element-448">{step}</span>
                  </a>
                </>}
              <div className="absolute top-10 left-1/2 -translate-x-1/2 whitespace-nowrap text-xs font-medium text-gray-500" data-id="element-449">
                {step}
              </div>
            </li>;
      })}
      </ol>
    </nav>;
}